import React, { lazy, Suspense } from 'react';
const BarComponent = lazy(() => import('./index'));

const WrapperBarComponent = ({ data, text, options, shouldLoad = true }) => {
    return (
        <>
            {shouldLoad && (
                <Suspense fallback={<div>Cargando gráfico...</div>}>
                    <BarComponent text={text} data={data} options={options} />
                </Suspense>
            )}
        </>
    );
};

export default WrapperBarComponent;
